//所有有关用户信息的网络请求
import http from '../utils/http'

//根据ID查询
export function apiClientinfo(id){
    return http({
      url:`/client/ccManage/${id}`,
      method:'get',
    })
}

//查询全部数据
export function apiClientList({page,size}){
  return http({
    url:`/client/ccManage/${page}/${size}`,
    method:'post',
  })
}
//新增
export function apiAddClientList(data){
  return http({
    url:'/client/ccManage',
    method:'post',
    data
  })
}
//编辑
export function apiEditClientList({id,data}){
  return http({
    url:`/client/ccManage/${id}`,
    method:'put',
    data
  })
}
//删除
export function apiDeleteClientList(id){
  return http({
    url:`/client/ccManage/${id}`,
    method:'delete',
  })
}
//根据多条件查询
export function apiClientSearch(params){
  return http({
    url:`/client/ccManage`,
    method:'Get',
    params:params,
  })
}
//导入
export function apiImportFile(params){
  return http({
    url:'/client/ccManage/upload',
    method:'post',
    data:params,
    headers:{
      'content-type':'multipart/form-data'
    }
  })
}
// 导出客诉管理
export function apiClientExport(params){
  return http({
    url:`/client/ccManage/download`,
    method:'get',
    params:params,
    responseType: 'blob'
  })
}
// 获取客服邮箱
export function apiClientEmail(){
  return http({
    url:'/user/customer',
    method:'get'
  })
}
// 根据内部sku获取卖家sku集合数据
// export function apiClientSku(psku){
//   return http({
//     url:`/user/listing/checkPsku/${psku}`,
//     method:'get',
//   })
// }